// extracted by mini-css-extract-plugin
module.exports = {"sessions":"SessionsPanel_sessions__3bgCm","buttons":"SessionsPanel_buttons__I_9ib"};